import React from "react";
import Background from "@/components/landing/Background";
import AppHeader from "@/components/nav/AppHeader";

/**
 * Onboarding pages chrome. Uses the unified `AppHeader mode="onboarding"`
 * which renders the AutoAds logo, an inline 1—2—3 progress, and an exit button.
 */
export default function OnboardingShell({ current, children }) {
    return (
        <div className="min-h-screen relative" data-testid="onboarding-shell">
            <Background />
            <div className="relative z-10">
                <AppHeader mode="onboarding" currentStep={current} />
                <main className="container-mx py-10">{children}</main>
            </div>
        </div>
    );
}
